import { render, staticRenderFns } from "./AttentionArea.vue?vue&type=template&id=a7d20858&scoped=true&"
import script from "./AttentionArea.vue?vue&type=script&lang=js&"
export * from "./AttentionArea.vue?vue&type=script&lang=js&"
import style0 from "./AttentionArea.vue?vue&type=style&index=0&id=a7d20858&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d20858",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VIcon,VRow,VSheet})
